import Vue from 'vue'
import Router from 'vue-router'
import startPage from '@/components/startPage'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'startPage',
      component: startPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js